import { PrefetchApiConfigItemType } from "@al/next/dist/lib/al-ex/prefetchApi";
import { LocaleType } from "@al/next/al-ex";
import { IO, IoResponse } from "@al/base-lib";

type AsyncFuncParamsType = (
  params: Record<string, unknown>,
  ctx: { io: IO; locale: LocaleType; deviceId: string }
) => Promise<IoResponse<unknown>>;
export type AsyncFuncType = (params: AsyncFuncParamsType) => Promise<IoResponse<unknown>>;
export type AsyncFuncInputType = { async: AsyncFuncType };

const request = (async: AsyncFuncType, url: string, methods = "post"): Promise<IoResponse<unknown>> =>
  async((params, ctx) =>
    ctx.io[methods as "post"](
      url,
      { countryId: ctx.locale.countryId, ...params },
      { headers: { "Content-Type": "application/json", "device-id": ctx.deviceId } }
    )
  );

const prefetchConfig = (url: string, data = {}, method: "GET" | "POST" = "POST"): PrefetchApiConfigItemType => ({
  url,
  method,
  type: "JSON",
  data: {
    countryId: "$cookie.countryId?$cookie.countryId:1",
    ...data,
  },
});

export { request, prefetchConfig };

export default {
  // 获取文件上传地址
  getUploadUrl: "/capi/personal/user/upload/url/get",
  // 页面详情数据
  getPageDetail: "/capi/growth/public/customerPage/detail",
  // 分享码
  getShareCode: "/capi/growth/distribution/code/get",
};
